import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import HomeRu from './HomeRu';
import HomeFr from './HomeFr';
import HomeEs from './HomeEs';
import HomeAr from './HomeAr';

import Referral from './Referral';
import TermsOfUs from './TermsOfUs';
import PrivacyPolicy from './PrivacyPolicy';
import AccessibilityStatement from './AccessibilityStatement';

import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>

  <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/ru" element={<HomeRu />} />
        <Route path="/fr" element={<HomeFr />} />
        <Route path="/ar" element={<HomeAr />} />
        <Route path="/es" element={<HomeEs />} />

        <Route path="/termsOfUse" element={<TermsOfUs/>} />
        <Route path="/termsOfUs" element={<TermsOfUs/>} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
        <Route path="/accessibilityStatement" element={<AccessibilityStatement/>} />
        <Route path="/feedbackRating" element={<Referral url={"https://forms.fillout.com/t/7VwWfyEptLus"}/>} />
        <Route path="/sendFeedBack" element={<Referral url={"https://forms.fillout.com/t/5r8Uhv1J1zus"}/>} />
        <Route path="/reportAProblem" element={<Referral url={"https://forms.fillout.com/t/fUmM9w8ybZus"}/>} />
        <Route path="/suggestAFeature" element={<Referral url={"https://forms.fillout.com/t/enYXujWBcmus"}/>} />
        
      </Routes>
  </BrowserRouter>
);
